import CSRF from 'csrf'
import { toast } from 'vanillaToast'

document.addEventListener('DOMContentLoaded', () => {
  const thumbnailImages = document.querySelectorAll('.js-thumbnail-image')
  if(!thumbnailImages) return

  thumbnailImages.forEach(thumbnailImage => {
    const deleteBtn = thumbnailImage.parentElement.querySelector('.a-button')
    if(thumbnailImage && deleteBtn) {
      bindDeleteBtnEvent(deleteBtn)
    }
  })
})

// 削除ボタン用のイベント処理を設定
function bindDeleteBtnEvent(deleteBtn) {
  deleteBtn.addEventListener('click', () => {
    if (!confirm('画像を削除しますか？')) return
    const img = deleteBtn.parentElement.parentElement.querySelector('.js-file-input__preview img')
    const deleteUrl = deleteBtn.dataset.url

    // 画像がDBに保存されている場合
    if (deleteUrl) {
      deleteThumbnailImage(deleteUrl, img, deleteBtn)

    }
    else {
      clearThumbnailImagePreview(img, deleteBtn)
    }
  })
}

// 画像削除処理
function deleteThumbnailImage(deleteUrl, img, deleteBtn) {
  fetch(deleteUrl, {
    method: 'DELETE',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': CSRF.getToken()
    },
    credentials: 'same-origin',
    redirect: 'manual'
  })
  .then((response) => {
    if (response.ok) {
      clearThumbnailImagePreview(img, deleteBtn)

      // 2回目は画像がDBに保存されていないため、url属性を削除し削除ボタンを非表示のみに設定させる
      deleteBtn.removeAttribute('data-url')
    }
    else if(response.status == 404){
      toast('画像は既に削除されているので、一度画面をリロードしてください。')
    }
    else if(response.status == 500){
      toast('サーバーエラーが発生しました。しばらくしてから再試行してください。')
    }
    else {
      console.warn(`予期しないエラーが出ました。(ステータス: ${response.status})`)
      toast(`予期しないエラーが出ました。(ステータス: ${response.status})`)
    }
  })
  .catch((error) => {
    console.warn(error)
    toast('画像の削除に失敗しました。')
  })
}

// 画像と削除ボタンを非表示
function clearThumbnailImagePreview(img, deleteBtn) {
  toast('画像を削除しました。')
  if (img) img.remove()
  const fileInput = deleteBtn.parentElement.parentElement.querySelector('input[type="file"]')
  fileInput.value = ''
  deleteBtn.parentElement.style.display = 'none'
}

// 外部呼び出し用
export function RemoveThumbnailImage() {
  const thumbnailImageDeletes = document.querySelectorAll('.js-thumbnail-image-delete')

  thumbnailImageDeletes.forEach(thumbnailImageDelete => {
    if(!thumbnailImageDelete.parentElement.querySelector('img')) return

    const deleteBtn = thumbnailImageDelete.querySelector('.a-button')
    if (deleteBtn) {
      deleteBtn.parentElement.style.display = 'block'
    }
    else {
      createDeleteBtn(thumbnailImageDelete)
      bindDeleteBtnEvent(thumbnailImageDelete.querySelector('.a-button'))
    }
  })
}

// 削除ボタン用の要素を作成
function createDeleteBtn(thumbnailImageDelete) {
  const newDeleteBtn = document.createElement('button')
  newDeleteBtn.textContent = '画像を削除'
  newDeleteBtn.type = 'button'
  newDeleteBtn.className = 'a-button is-sm is-danger'
  thumbnailImageDelete.appendChild(newDeleteBtn)
}
